module.exports = __webpack_public_path__ + "img/goggle-play-icon.e7db140c.webp";